import { LanguageCode } from '@communication-center/data-objects';
import { uiActions } from '../actionTypes/ui';

export interface IUIState {
    snackbarNotifications: $TSFixMe[];
    languageCode: LanguageCode;
}

const uiInitialState: IUIState = {
    snackbarNotifications: [],
    languageCode: LanguageCode.EN
};

export default (state = uiInitialState, action: $TSFixMe) => {
    switch (action.type) {
        case uiActions.ENQUEUE_SNACKBAR:
            return {
                ...state,
                snackbarNotifications: [
                    ...state.snackbarNotifications,
                    {
                        key: action.key,
                        ...action.notification
                    }
                ]
            };

        case uiActions.CLOSE_SNACKBAR:
            return {
                ...state,
                snackbarNotifications: state.snackbarNotifications.map(notification =>
                    notification.key === action.key ? { ...notification, dismissed: true } : { ...notification }
                )
            };

        case uiActions.REMOVE_SNACKBAR:
            return {
                ...state,
                snackbarNotifications: state.snackbarNotifications.filter(notification => notification.key !== action.key)
            };

        case uiActions.SET_LANGUAGE:
            return {
                ...state,
                languageCode: action.languageCode
            };

        default:
            return state;
    }
};
